import React from 'react';
import { Grid, Typography, Box, Card, CardMedia, CardContent } from "@material-ui/core";
import styled from 'styled-components'
import ButtonAtom from '../../component/ButtonAtom/index.jsx'
import TextfieldAtom from '../../component/Textfield/index.jsx'
import { makeStyles } from '@material-ui/styles';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Avatar from '@mui/material/Avatar';
import ReplyIcon from '@mui/icons-material/Reply';
import ContactList from './../../component/ContactList/index';
import PersonIcon from '@mui/icons-material/Person';
import TabsAtom from './../../component/TabsAtom/index'

const Folder = () => {
    const classes = useStyles();
    
    return (
        <Grid p={2} className={classes.commonSectionBuild}>
          
          <Box className={classes.cornerBorder}>
                <TabsAtom />
                <ContactList />
            </Box>
        </Grid>

    )
};

const useStyles = makeStyles(() => ({
    headerBrowser: {
        background: '#fff',
        color: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 0',
        alignItems: 'center',
        overflowX: 'auto',
        '& > .MuiBox-root': {
            minWidth: '33.33%',
            margin: 0,
            borderRadius: 0,
        }
    },
    commonSectionBuild: {
        maxWidth: 540,
        float: 'none',
        margin: '0 auto',
        padding: '0 15px',
        boxSizing: 'border-box',
    },
    text: {
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',

    },
    headerBrowser1: {
        background: '#fff',
        color: 'black',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
    },
    headerBrowser2: {
        background: '#fff',
        color: 'black',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        alignItems: 'center',
        position: 'relative',
        '& input': {
            paddingLeft: 50,
        }

    },
    commonNameCenter: {
        alignItems: 'center',
        marginLeft: '180px',
        marginRight: '60px',
        size: '20px',
    },
    headerBrowser3: {
        position: 'absolute',
        top: 25,
        left: 30,
    },
    cornerBorder: {
        paddingTop: 20,
        borderRadius: '40px 40px 0 0',
        boxSizing: 'border-box',
    }

}));

export default Folder;